import { useState } from "react";
import Molecule from "../../../MComponent/Molecule";
import Atomic from "../../../AComponent/Atomic";
import {
  getData,
  generateReport,
  getDateFromEpoch,
  getUserId,
} from "../../../Utils/Common/Library";
import FeatureIDs from "../../../Utils/Common/FeatureIDs";
import { Typography } from "@mui/material";
import ReportsTable from "./ReportsTable";
import mappings, { periodMapping } from "./data";
import AlertMessage from "../../../Utils/Messages/AlertMessage";
import Applicability6 from "../../../MComponent/Applicability/Applicability5";
import extract from "./ExtractApplicabilityData";

const { EwModal, Tabs } = Molecule;
const { Dropdown, Button } = Atomic;

const planPeriodForAllOption = [
  {
    ReviewFromDate: "1751308200000",
    ReviewTillDate: "1782757800000",
    label: "Jul 1 2025 - Jun 30 2026",
    value: 2,
  },
  {
    ReviewFromDate: "1719772200000",
    ReviewTillDate: "1751221800000",
    label: "Jul 1 2024 - Jun 30 2025",
    value: 1,
  },
];

const showAllReportType = ["PS", "PT", "AR", undefined];

function PlanProgress({ onClose, reportType, isAppraiser }) {
  console.log("PLAN PROgress: ", reportType, isAppraiser);

  const [PlanList, setPlanList] = useState([]);
  const [selectedPLanPeriod, setSelectedPlanPeriod] = useState(-1);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [DimensionID, setDimensionID] = useState(-1);
  const [serverData, setServerData] = useState({});
  const [message, setMessage] = useState(null);
  const [disableButton, setDisableButton] = useState(false);
  const [applicabilityFilter, setApplicabilityFilter] = useState(null);

  function planSelected(planId) {
    setSelectedPlan(planId);
    setSelectedPlanPeriod(-1);
    setDimensionID(-1);
    setPlanList([]);
    setServerData((prev) => ({ ...prev, periods: null }));
    if (planId === 1) {
      setPlanList(planPeriodForAllOption);
      return;
    }

    getData({
      featureId: FeatureIDs.PerformanceCycleInitiation,
      payload: { "Data.MPPID": planId },
    }).then((res) => {
      if (res?.Data) {
        let arr = res.Data.map((ele) => {
          console.log("Test ele is: ", ele.PlanCycleEndDate);
          let planPeriod =
            getDateFromEpoch({ epoch: +ele.PlanCycleStartDate }) +
            " - " +
            getDateFromEpoch({ epoch: +ele.PlanCycleEndDate });
          return {
            label: planPeriod,
            value: ele.TransactionID,
            ReviewFromDate: ele.PlanCycleStartDate,
            ReviewTillDate: ele.PlanCycleEndDate,
          };
        });
        console.log("Array is : ", arr);
        setPlanList([...arr]);
      }
    });
  }
  function onSubmit() {
    const isAllSelected = selectedPlan === 1;
    const listToCheck = isAllSelected ? planPeriodForAllOption : PlanList;
    let doc = listToCheck.find((item) => item.value === selectedPLanPeriod);
    const { plans, dimensions } = serverData;

    const DimensionIDValue = dimensions?.find((item) => item.value === DimensionID)?.label;
    const MasterPerformancePlanIDValue = plans?.find((item) => item.value === selectedPlan)?.label;
    const ReviewPeriodUnit = "A";
    console.log("Server data: ", DimensionIDValue, " ", MasterPerformancePlanIDValue);
    if (!DimensionIDValue || (!MasterPerformancePlanIDValue && !isAllSelected)) return;
    if (!doc) return;
    const { ReviewFromDate, ReviewTillDate } = doc;

    let requiredFields = [
      { DimensionID, DimensionIDValue },
      {
        ReviewPeriodUnit,
        ReviewPeriodUnitValue: periodMapping[ReviewPeriodUnit]
          ? periodMapping[ReviewPeriodUnit]
          : "Month",
      },
      {
        ReviewFromDate,
        ReviewFromDateValue: getDateFromEpoch({
          epoch: ReviewFromDate,
          format: 1,
        }),
      },
      {
        ReviewTillDate,
        ReviewTillDateValue: getDateFromEpoch({
          epoch: ReviewTillDate,
          format: 1,
        }),
      },
      ...extract(applicabilityFilter),
    ];
    if (!isAllSelected) {
      requiredFields.push({
        MasterPerformancePlanID: selectedPlan,
        MasterPerformancePlanIDValue,
      });
    }

    console.log("Get Report: ", requiredFields);

    // setMessage({
    //   type: 3,
    //   message:
    //     "The report is in the process of being generated and may take a while. Kindly check downloads tab after some time.",
    // });
    setDisableButton(true);

    if (isAllSelected && reportType) {
      reportType = "All" + reportType;
    }
    console.log("REPORT TYPE: ", reportType);

    const payload = {
      queryName: mappings[reportType ? reportType : isAllSelected ? "AllPT" : "PT"],
      requiredFields,
    };
    if (isAppraiser) {
      payload.queryName =
        mappings[reportType ? "A" + reportType : isAllSelected ? "AllAPT" : "APT"];
      payload.AppraiserUserID = getUserId();
    }

    generateReport(payload)
      .then((res) => {
        if (res.success === "1") {
          setMessage({
            type: 0,
            message: res.message,
          });
        } else {
          setMessage({
            type: 1,
            message: res.message,
          });
        }
      })
      .catch((e) => {
        console.log("Error: ", e);
        setMessage({
          type: 1,
          message: "Network Error",
        });
      })
      .finally(() => {
        setDisableButton(false);
      });
  }

  function Report() {
    return (
      <>
        <div className="Flex-row g20" style={{ width: "100%" }}>
          <Dropdown
            styles={{ width: "100%" }}
            label={"Select Plan"}
            featureId={FeatureIDs.MasterPerformancePlan}
            mapper={{ label: "PlanName", value: "TransactionID" }}
            value={selectedPlan}
            onChange={planSelected}
            storeApiResult={(data) => {
              if (showAllReportType.includes(reportType) && !isAppraiser) {
                data = [{ label: "All Plans", value: 1 }, ...data];
              }

              console.log("Data is: ", data);

              setServerData((prev) => ({ ...prev, plans: data }));
            }}
            apiResult={serverData.plans}
          />
          {PlanList?.length > 0 && (
            <Dropdown
              label={"Plan Period"}
              styles={{ width: "100%" }}
              menuItems={PlanList}
              value={selectedPLanPeriod}
              onChange={(val) => {
                console.log("val is: ", val);
                setSelectedPlanPeriod(val);
                setServerData((prev) => ({ ...prev, dimensions: null }));
                setDimensionID(null);
              }}
              mapper={{ label: "planPeriod", value: "TransactionID" }}
              storeApiResult={(data) => setServerData((prev) => ({ ...prev, periods: data }))}
              apiResult={serverData.periods}
            />
          )}
        </div>

        <br />
        {selectedPLanPeriod !== -1 && (
          <div className="Flex-row g20">
            <Dropdown
              styles={{ width: "100%" }}
              label={"Dimensions"}
              featureId={FeatureIDs.PerformanceDimensionGrouping}
              mapper={{
                label: "DimensionName",
                value: "TransactionID",
              }}
              value={DimensionID}
              onChange={(val) => {
                setDimensionID(val);
                setServerData((prev) => ({ ...prev, assessment: null }));
              }}
              storeApiResult={(data) => setServerData((prev) => ({ ...prev, dimensions: data }))}
              apiResult={serverData.dimensions}
            />
          </div>
        )}
        {message && (
          <>
            {" "}
            <br />
            <AlertMessage {...message} onClose={() => setMessage(null)} />
          </>
        )}
        <br />

        <br />
        {DimensionID && DimensionID !== -1 && (
          <div className="Flex g20">
            <Applicability6
              onChange={setApplicabilityFilter}
              value={applicabilityFilter}
              passPayload={true}
              AuthorFeatureID={"Reports"}
            />

            <Button disable={disableButton} title={"Generate New Report"} onClick={onSubmit} />
          </div>
        )}
      </>
    );
  }
  return (
    <EwModal open={true} onClose={onClose}>
      <div className="scroll" style={{ width: 900, minHeight: 300, maxHeight: 500 }}>
        <div className="Flex">
          <Typography variant="h1">
            {reportType === "AR" ? "Appraisal Report" : "Plan Progress Report"}
          </Typography>
        </div>
        <br />
        <Tabs
          componentList={[
            { label: "Generate Report", Component: Report },
            {
              label: "Download Reports",
              Component: ReportsTable,
              props: {
                type: reportType
                  ? isAppraiser
                    ? "A" + reportType
                    : reportType
                  : isAppraiser
                  ? "APT"
                  : "PT",
                isAppraiser,
              },
            },
          ]}
        />
      </div>
    </EwModal>
  );
}

export default PlanProgress;
